import { Component, computed, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink } from '@angular/router';
import { LocalStorageService } from '../../core/localStorageService';
import { MceApiService } from '../../core/mceapi.client.generated';

@Component({
    selector: 'mce-projects-status',
    imports: [MatCardModule, MatIconModule, MatButtonModule, MatIconModule, RouterLink],
    templateUrl: './projects-status.component.html',
})
export class ProjectsStatusComponent {

  private localStoreService = inject(LocalStorageService);
  private mceApiService = inject(MceApiService);
  private router = inject(Router);

  recentProjectsResource = rxResource({ 
    stream: () => this.mceApiService.v1ProjectsList(this.localStoreService.recentProjects()),
  })
  recentProjects = computed(() => this.recentProjectsResource.value());

  protected readonly viewModel = computed(() => {
    return {
      recentProjects: this.recentProjects(),
      showRecentProjects: this.localStoreService.recentProjects().length > 0,
    };
  });

  protected get vm() { return this.viewModel(); }

onClick(projectUid: string | undefined) {
  if (!projectUid) return;

  this.localStoreService.recentProjectsAddProject(projectUid);
  this.router.navigate(['/cables', projectUid]);
};

}

